import React from "react";
import { useTranslation } from "react-i18next";
import classes from "./QabulStatus.module.css";

const QabulStatus = () => {
  const { t } = useTranslation();

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <div className={classes.messageCard}>
          <div className={classes.closedSection}>
            <div className={classes.iconCircle + " " + classes.red}>
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" fill="currentColor" />
              </svg>
            </div>
            <p className={classes.messageText}>{t("qabul_2025_2026_closed")}</p>
          </div>

          <div className={classes.divider}></div>

          <div className={classes.upcomingSection}>
            <div className={classes.animatedIconWrapper}>
              <div className={classes.calendarIcon}>
                <div className={classes.calendarTop}></div>
                <div className={classes.calendarBody}>
                  <div className={classes.calendarDate}>
                    <span className={classes.year}>2026</span>
                    <span className={classes.separator}>/</span>
                    <span className={classes.year}>2027</span>
                  </div>
                  <div className={classes.clockHands}>
                    <div className={classes.hourHand}></div>
                    <div className={classes.minuteHand}></div>
                  </div>
                </div>
              </div>
            </div>
            <p className={classes.messageText}>{t("qabul_2026_2027_soon")}</p>
          </div>
        </div>

        <div className={classes.contactSection}>
          <p className={classes.contactTitle}>{t("qabul_contact_info")}</p>
          <div className={classes.contactButtons}>
            <a href="tel:+998555067007" className={classes.contactButton}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
              </svg>
              +998 55 506 70 07
            </a>
            <a href="mailto:info-rtu@renessans-edu.uz" className={classes.contactButton}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
              </svg>
              info-rtu@renessans-edu.uz
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
  
export default QabulStatus;
